module.exports = __webpack_public_path__ + "img/slika40.023ee45b.jpg";